/*
=========================================================
* RingOperator Homepage Theme Helpers — Dispatch design
=========================================================
*/

// Core palette
export const brandPrimary = "#0E0D0B";      // near-black ink
export const brandSecondary = "#1A1915";    // deeper ink
export const brandAccent = "#3A5BD9";       // cobalt (oklch ~ 0.55 0.22 260)
export const brandCream = "#F4F1EA";        // page bg
export const brandCard = "#FFFFFF";         // card surface

// Gradients
export const brandGradient = `linear-gradient(135deg, ${brandPrimary} 0%, ${brandSecondary} 100%)`;
export const brandSoftGradient = `linear-gradient(135deg, rgba(58,91,217,0.06) 0%, rgba(14,13,11,0.04) 100%)`;
export const brandSoftRow = "rgba(14,13,11,0.04)";

// Greys
export const grey100 = "#F4F1EA";
export const grey200 = "#EDEAE2";
export const grey300 = "#E0DCD2";
export const grey400 = "#B2ADA3";
export const grey500 = "#8A857B";
export const grey600 = "#5F5B53";
export const grey700 = "#3E3B36";
export const grey800 = "#242220";
export const grey900 = "#14120F";

// Accent status colors
export const accentSuccess = "#1F9D6D";
export const accentInfo = "#3A5BD9";
export const accentWarning = "#D48A1F";
export const accentError = "#D93B3B";

// Shared CSS injected into the homepage
export const dispatchCss = `
@import url('https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700;800&family=Instrument+Serif:ital@0;1&family=JetBrains+Mono:wght@400;500;600&display=swap');
.ro-root, .ro-root * { font-family: 'Geist', system-ui, -apple-system, Segoe UI, sans-serif; }
.ro-serif { font-family: 'Instrument Serif', Georgia, serif; font-weight: 400; }
.ro-mono { font-family: 'JetBrains Mono', ui-monospace, monospace; }
@keyframes ro-marquee { from { transform: translateX(0) } to { transform: translateX(-50%) } }
@keyframes ro-pulse { 0% { transform: scale(1); opacity: .7 } 100% { transform: scale(3); opacity: 0 } }
@keyframes ro-drop { from { opacity: 0; transform: translateY(14px) } to { opacity: 1; transform: translateY(0) } }
@keyframes ro-float { to { transform: translateY(-8px) } }
@keyframes ro-orbit { to { transform: rotate(360deg) } }
`;
